import React from 'react';
import styled from 'styled-components';
import Colors from '../../ui/global/Colors';
import Fonts from '../../ui/global/Fonts';
import Logo from '../../ui/components/Logo';

const HeroContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: fit-content;
    text-align: center;
    // margin: 16vh 0;
    margin: 12.2vh 0;
    gap: 20px;
    overflow: visible;
    z-index: 10;
`;

const Title = styled.h1<{ $colorMode: 'light' | 'dark' }>`
    font-family: ${Fonts.lexendBold.fontFamily};
    font-weight: ${Fonts.lexendBold.fontWeight};
    font-size: 10vw;
    line-height: 1em;
    margin: 0;
    color: ${props => props.$colorMode === 'light' ? Colors.black : Colors.white};
    // text-shadow: -1px -1px 0 ${props => props.$colorMode === 'light' ? Colors.white : Colors.black},
    //              1px -1px 0 ${props => props.$colorMode === 'light' ? Colors.white : Colors.black},
    //              -1px 1px 0 ${props => props.$colorMode === 'light' ? Colors.white : Colors.black},
    //              1px 1px 0 ${props => props.$colorMode === 'light' ? Colors.white : Colors.black};

    @media (min-width: 1280px) {
        font-size: 120px;
    }

    @media (max-width: 1024px) {
        font-size: 12vw;
    }

    @media (max-width: 400px) {
        font-size: 72px;
    }
`;

const Subtitle = styled.h4<{ $colorMode: 'light' | 'dark'; $size?: 'default' | 'small' }>`
    font-family: ${Fonts.lexendLight.fontFamily};
    font-weight: ${Fonts.lexendLight.fontWeight};
    font-size: ${props => props.$size === 'small' ? '4vw' : '5vw'};
    line-height: 1.2em;
    text-wrap: balance;
    color: ${props => props.$colorMode === 'light' ? Colors.grey6 : Colors.grey3};
    margin: 0;
    text-shadow: -0.5px -0.5px 0 ${props => props.$colorMode === 'light' ? Colors.white : Colors.black},
                 0.5px -0.5px 0 ${props => props.$colorMode === 'light' ? Colors.white : Colors.black},
                 -0.5px 0.5px 0 ${props => props.$colorMode === 'light' ? Colors.white : Colors.black},
                 0.5px 0.5px 0 ${props => props.$colorMode === 'light' ? Colors.white : Colors.black};

    @media (min-width: 1280px) {
        font-size: ${props => props.$size === 'small' ? '40px' : '60px'};
    }

    @media (max-width: 1024px) {
        font-size: ${props => props.$size === 'small' ? '4vw' : '5vw'};
    }

    @media (max-width: 400px) {
        font-size: ${props => props.$size === 'small' ? '24px' : '36px'};
        margin: 0 10px;
    }
`;

interface HeroProps {
    title: string;
    subtitle: string;
    subtitleSize?: 'default' | 'small';
    colorMode?: 'light' | 'dark';
    children: any;
}

const Hero: React.FC<HeroProps> = ({ title, subtitle, subtitleSize='default', colorMode='dark', children }) => {
    return (
        <HeroContainer id='hero-container'>
            <Logo colorMode={colorMode} size={18} text='right' caps={true} />
            <Title $colorMode={colorMode}>
                {title}
            </Title>
            <Subtitle $colorMode={colorMode} $size={subtitleSize}>
                {subtitle}
            </Subtitle>
            {children}
        </HeroContainer>
    )
};

export default Hero;